import { Component } from '@angular/core';

@Component({
  selector: 'app-content-card8',
  imports: [],
  templateUrl: './content-card8.component.html',
  styleUrl: './content-card8.component.scss'
})
export class ContentCard8Component {

}
